import { render } from "./CategoryFaqList.vue?vue&type=template&id=91650168&scoped=true"
import script from "./CategoryFaqList.vue?vue&type=script&lang=js"
export * from "./CategoryFaqList.vue?vue&type=script&lang=js"

import "./CategoryFaqList.vue?vue&type=style&index=0&id=91650168&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manzurul\\AppData\\Local\\Jenkins.jenkins\\workspace\\Course-Manager-Support-Production\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91650168"]])

export default __exports__